import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import CountUp from "react-countup";
import classes from "./styles.module.scss";
import VisibilitySensor from "react-visibility-sensor";
import { Title, Description } from "@/ui";

export default function StatCounterWidget({ sectionId, className, bgColor, title, description, items }) {
  return (
    <div id={sectionId} className={clsx(className, bgColor, classes.StatCounterWidget)}>
      <VisibilitySensor>
        {() => (
          <Container>
            <Title title={title} tag="h5" className="mb-5" />
            <Row>
              {items.map((i, k) => (
                <Col key={k} xs={12} md={4} className="mb-4 mb-md-0">
                  <dl>
                    <dd>
                      {i?.prefix}
                      <CountUp end={i?.value} redraw={true} />
                      {i?.suffix}
                    </dd>
                    <dt>{i?.label}</dt>
                  </dl>
                </Col>
              ))}
            </Row>
            <Description description={description} className="mt-5 small" />
          </Container>
        )}
      </VisibilitySensor>
    </div>
  );
}
